import React from "react";
import Contact from "../Contact";
import PSide from "./pathSideBar";
const affmap = new URL('../images/pathimages/affinitymappath.png', import.meta.url).href;
const journey = new URL('../images/pathimages/pathjourney.png', import.meta.url).href;
import Problem from "./pathPD.js";
import PathSol from "./pathsol.js";
import DesignDeepDive from "./DesignDeepDive.js";
import DesignIteration from "./DesignIteration.js";
import Results from "./Results.js";
import WhatILearned from "./WhatILearned.js";

const path = new URL('../images/pathimages/path.png', import.meta.url).href;

export default function PatpProjectPage() {
  return (
    <main id="top" className="bg-white-background text-black font-sans">
      <PSide />
      {/* Top grid line with border style */}
      <div className="bg-white-background pr-0 pl-48">
        <div className="w-full h-5 border-1 border-t-0 border-grid" />

        {/* Row */}
        <div className="w-full h-20 flex flex-row border-l-1 border-r-1 border-b-1 border-grid">
          <div className="relative flex-1 flex items-center px-10 text-3xl font-medium">
            <div className="absolute -top-3 -left-3 w-3 h-3 border-r-1 border-b-1 border-off-black">
              <div className="absolute w-3 h-3 border-off-black border-t-1 border-l-1 -bottom-3 -right-3" />
            </div>
            PATH@PENN REDESIGN
          </div>
        </div>
      </div>

      <section className="bg-white-background pr-0 pl-48">
        {/* Outer frame (top+left+right) */}
        <div className="h-fit border-l-1 border-r-1 border-t-0 border-grid">
          {/* Top strip */}
          <div className="w-full h-5 border-b-1 border-grid" />

          {/* Content row (text left, image right) */}
          <div className="grid lg:grid-cols-12 gap-6 p-10 border-b-1 border-grid">
            {/* Left: meta + headline */}
            <div className="lg:col-span-5 flex flex-col justify-between text-off-black">
              <div className="space-y-2">
                <div className="text-xs tracking-widest text-off-black/50">
                  PERSONAL PROJECT · SPRING 2025
                </div>
                <h2 className="text-3xl leading-snug font-medium">
                  A redesign that simplifies the course search and registration process for Penn students
                </h2>
              </div>

              <div className="mt-8 grid grid-cols-3 gap-4 text-sm">
                <div>
                  <div className="text-off-black/50">TIMELINE</div>
                  <div>Feb 2025 — Apr 2025</div>
                </div>
                <div>
                  <div className="text-off-black/50">ROLE</div>
                  <div> Product designer</div>
                </div>
              </div>
            </div>

            {/* Right: mock image in bordered card */}
            <div className="lg:col-span-7">
              <div className="relative group rounded-lg overflow-hidden border border-grid">
                <img
                  alt="Path@Penn mock"
                  src={path} /* <-- replace with your image */
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* Bottom corner accent */}
          <div className="relative">
            <div className="absolute -top-[11px] -left-3 w-3 h-3 border-r-1 border-b-1 border-off-black">
              <div className="absolute w-3 h-3 border-off-black border-t-1 border-l-1 -bottom-3 -right-3" />
            </div>
          </div>
        </div>
      </section>

      {/* Continue with rest of project sections as before */}

      {/* Intro Section */}
      <div id="intro" className="bg-white-background pr-0 pl-48">
        {/* Top border line */}
        <div className="w-full h-5 border-1 border-t-0 border-grid" />

        <div className="relative w-full border-1 border-t-0 border-grid p-10">
          {/* Corner accents (optional, same style as header) */}
          <div className="absolute -top-3 -left-3 w-3 h-3 border-r-1 border-b-1 border-off-black">
            <div className="absolute w-3 h-3 border-off-black border-t-1 border-l-1 -bottom-3 -right-3" />
          </div>

          <p className="text-xs tracking-widest text-off-black/50 mb-2">INTRODUCTION</p>
          <p className="text-xl leading-relaxed max-w-3xl">
            Course search, financial aid, degree audit, and more.
          </p>
          <p className="text-[.95rem] leading-relaxed text-off-black/70 max-w-3xl leading-snug">
            Path@Penn is the University of Pennsylvania's main student platform, offering many services to the student body. This project focuses on the course search and registration part of the platform
          </p>
        </div>
      </div>

      <div id="research" className="bg-white-background pr-0 pl-48">
        {/* Top border line */}
        <div className="w-full h-5 border-1 border-t-0 border-grid" />

        <div className="relative w-full border-1 border-t-0 border-grid p-10">
          {/* Corner accents */}
          <div className="absolute -top-3 -left-3 w-3 h-3 border-r-1 border-b-1 border-off-black">
            <div className="absolute w-3 h-3 border-off-black border-t-1 border-l-1 -bottom-3 -right-3" />
          </div>

          <p className="text-xs tracking-widest text-off-black/50 mb-2">USER RESEARCH</p>
          <p className="text-xl leading-relaxed max-w-3xl">Identifying pain points and goals.</p>
          <p className="text-[.95rem] leading-relaxed text-off-black/70 max-w-3xl leading-snug mb-8">
            Through interviews and task-based observations, I aimed to understand how students search for courses, build schedules, and use degree audit tools.
          </p>

          {/* Grid: two tables on top*/}
          <div className="grid gap-10 items-start">
            {/* TOP ROW: two tables side by side */}
            <div className="grid lg:grid-cols-2 gap-20">
              {/* LEFT: Questions Table */}
              <div className="h-fit border-1 border-grid">
                <div className="relative text-lg leading-relaxed h-14 w-full flex items-center px-6 font-medium border-b border-grid text-off-black max-w-3xl">
                  Questions I Asked
                </div>
                <div className="p-3 text-off-black/70">
                  <table className="w-full border-collapse">
                    <tbody>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          When deciding between classes, which information are you comparing, and how are you deciding?
                        </td>
                      </tr>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          Walk me through your course search, adding a course to cart, and submitting a schedule.
                        </td>
                      </tr>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          Show me how you would use the degree audit to check if you’re on track to graduate.
                        </td>
                      </tr>
                      <tr>
                        <td className="p-3">
                          If you could change one thing about this design, what would it be?
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* RIGHT: Participants Table */}
              <div className="h-fit border-1 border-grid">
                <div className="relative text-lg leading-relaxed h-14 w-full flex items-center px-6 font-medium border-b border-grid text-off-black max-w-3xl">
                  People I Interviewed
                </div>
                <div className="p-3 text-off-black/70">
                  <table className="w-full border-collapse">
                    <tbody>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">Undergraduate and graduate students</td>
                      </tr>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          Students from all 4 schools: College of Arts & Sciences, Engineering, Nursing, and Wharton
                        </td>
                      </tr>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          Freshmen -{'>'} seniors that have used PennInTouch (previous version of Path@Penn)
                        </td>
                      </tr>
                      <tr className="border-b-1 border-grid">
                        <td className="p-3">
                          Students with nontraditional degrees and requirements (dual degrees, transfers)
                        </td>
                      </tr>
                      <tr>
                        <td className="p-3">Students from other universities for comparative insights</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> 
            </div>
          </div>
          <p className="text-xl leading-relaxed max-w-3xl mb-1 mt-10">
              Mapping friction across the course planning flow</p>
            <p className="text-[.95rem] leading-relaxed text-off-black/70 max-w-3xl leading-snug mb-8">
              Students often lose confidence when building schedules, as details and actions are scattered across multiple surfaces. To locate the biggest pain points, I mapped the user journey and synthesized interview data with an affinity map to uncover recurring themes and opportunities.</p>
            
            {/* Journey Map (image card) */}
            <div className="mb-8">
              <div className="relative border-1 border-grid rounded-lg overflow-hidden w-full max-w-7xl">
                <img
                  src={journey}
                  alt="User Journey Map highlighting steps and frictions"
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="text-sm text-off-black/60 mt-2">Figure: Mapping the user journey and frictions.</div>
            </div>

            {/* Affinity Map (image card) */}
            <div>
              <div className="relative border-1 border-grid rounded-lg overflow-hidden w-full max-w-7xl">
                <img
                  src={affmap}
                  alt="Affinity Map clustering research findings and design ideas"
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="text-sm text-off-black/60 mt-2">Figure: Affinity map of themes and opportunities.</div>
            </div>
        </div>
      </div>

      <Problem journeySrc={journey} affmapSrc={affmap} />
      <PathSol />
      
      <DesignIteration
        iterations={[
          {
            title: "Initial Hi-Fi",
            image: { affmap },
            feedback:
              "Too dense on the right; unclear affordance for cart actions; calendar steals focus."
          },
          {
            title: "Second Version",
            image: { affmap },
            feedback:
              "Better hierarchy; add inline warnings; surface prereq status and seats."
          }
        ]}
        final={{
          title: "Final v1.0",
          image: { affmap },
          notes: "Resolves density and action clarity; aligns with style guide."
        }}
      />


      <DesignDeepDive
        styleGuide={{
          palette: [
            { name: "Red", hex: "#990000" },
            { name: "Blue", hex: "#011F5B" }
          ]
        }}
      />

      <Results
        metrics={[
          {
            label: "Time from course search to submit schedule",
            value: "−32%",
            note: "From 8m → 3.1m in tests"
          },
          {
            label: "Click reduction per task",
            value: "-60%",
            note:
              "Clicks required for degree planning, course scheduling, and schedule comparisons"
          },
          {
            label: "Ease-of-use score",
            value: "+78%",
            note: "From an average of 4.1/10 to 8.5/10"
          }
        ]}
        highlights={[
          "Students found it refreshing that all relevant information is placed conveniently",
          "Sandbox flows improved exploration without the stress of 'messing up' students' real plan",
          "88% reported less frustration and overwhelming-ness with clearer progress markers guiding each step"
        ]}
      />

      <WhatILearned
        lessons={[
          {
            title: "Validate early, not just intuit",
            detail:
              "Benchmarks and user tests corrected assumptions about density, action placement, and flows I initially thought would work."
          },
          {
            title: "Design for flow, not pages",
            detail:
              "Though different screens could theoretically keep things clean and separate, users need design flows that feel continuous and natural."
          },
          {
            title: "Navigate Bias in the Redesign Process",
            detail:
              "Being too familiar with Path@Penn made it harder to see fresh possibilities. I overcame this by grounding decisions in interviews and feedback, even from students outside Penn, to broaden my perspective."
          },
          {
            title: "Iteration is Key",
            detail:
              "No design is ever perfect. Iterating—through repeated interviews, redesigns, and refinements—was invaluable in aligning aesthetics and functionality with user needs."
          }
        ]}
      />
      <Contact />
    </main>
  );
}
